import * as types from "./consts";

export const postSetPasswordRequest = (payload: object) => ({
  type: types.POST_SET_PASSWORD_REQUEST,
  payload,
});
